module.exports = __webpack_public_path__ + "img/events-color.c8ee0ca.png";